import { TRegionAggregatedState } from './types';

export function getRegionAggregated(state: TRegionAggregatedState) {
  return state.regionAggregated;
}
